import { render, staticRenderFns } from "./price-channels.vue?vue&type=template&id=7d77ac54&"
import script from "./price-channels.vue?vue&type=script&lang=js&"
export * from "./price-channels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports